module.exports = __webpack_public_path__ + "static/media/disabled-icon.5ebacbfc.svg";